module.exports = __webpack_public_path__ + "img/li.557fd88e.svg";